// @flow
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import Modal from './Modal';
import SignupComponent from '../common/Signup';

import { selectOpenModalTypeIs } from '../../selectors/modals';
import * as uiActions from '../../actions/ui';
import * as authActions from '../../actions/auth';
import { selectSubscriptionFromId } from '../../selectors/subscriptionOffer';

type OwnProps = {
  location: Object,
};

type MapStateToProps = {
  isOpen: boolean,
  fromId: string,
};

type DispatchProps = {
  showModal: Function,
  hideModal: Function,
  onAuthComplete: Function,
};

type Props = OwnProps & MapStateToProps & DispatchProps;

const SignupModal = ({ isOpen, showModal, hideModal, location, fromId, onAuthComplete }: Props) => {
  const onClickLoginLink = event => {
    event.preventDefault();
    showModal('LOGIN_MODAL', { trigger: 'signupModal' });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={hideModal}
      onRequestClose={hideModal}
      contentLabel="signup-modal"
      role="dialog"
    >
      <div data-test="signup-modal">
        <SignupComponent
          onAuthComplete={() => onAuthComplete(location)}
          onClickLoginLink={onClickLoginLink}
          fromId={fromId}
        />
      </div>
    </Modal>
  );
};

function mapStateToProps(state: Object): MapStateToProps {
  return {
    isOpen: selectOpenModalTypeIs(state, 'SIGNUP_MODAL'),
    fromId: selectSubscriptionFromId(state),
  };
}

const dispatchProps: DispatchProps = {
  showModal: uiActions.showModal,
  hideModal: uiActions.hideModal,
  onAuthComplete: authActions.onAuthCompleteFromAuthModal,
};

export default connect(mapStateToProps, dispatchProps)(withRouter(SignupModal));
